import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    //账号密码登录检测是否有管理员账号
    CHECK_LOGIN_MANAGER(data) {
        controller='Login';
        action='CheckLoginManager';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


    //管理员登录
    LOGIN(data) {
        controller='Login';
        action='GoLogin';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //检测管理员是否登录
    MANAGER_LOGIN_CHECK(data) {
        controller='Login';
        action='CheckLogin';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },


    //管理员退出登录
    LOGIN_OUT(data) {
        controller='Login';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    //管理员退出登录
    MANAGER_LOGIN_OUT(data) {
        controller='Login';
        action='CheckLogin';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },


}